import {
  ActionIcon,
  Button,
  Group,
  Stack,
  Text,
  TextInput,
  Textarea,
} from '@mantine/core'
import { IconPlus, IconTrash } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

export function StringListField({ field, value, onChange, error }) {
  const { t } = useTranslation()
  return (
    <Textarea
      label={field.label}
      description={t('editorV2.form.fields.onePerLine')}
      value={(value || []).join('\n')}
      minRows={3}
      autosize
      error={error}
      onChange={(event) => {
        onChange(
          event.currentTarget.value
            .split('\n')
            .map((item) => item.trim())
            .filter(Boolean),
        )
      }}
    />
  )
}

export function ContactListField({ field, value, onChange, error }) {
  const { t } = useTranslation()
  const rows = value || []
  return (
    <Stack gap="xs">
      <Group justify="space-between">
        <Text size="sm" fw={500}>{field.label}</Text>
        <Button
          size="compact-xs"
          variant="subtle"
          leftSection={<IconPlus size={14} />}
          disabled={rows.length >= 4}
          onClick={() => onChange([...rows, { label: '', value: '' }])}
        >
          {t('editorV2.form.fields.addRow')}
        </Button>
      </Group>
      {rows.map((row, index) => (
        <Group key={index} wrap="nowrap" align="flex-end">
          <TextInput
            label={index === 0 ? t('editorV2.form.fields.label') : undefined}
            placeholder={t('editorV2.form.fields.phone')}
            value={row.label || ''}
            style={{ flex: 1 }}
            onChange={(event) => {
              const next = [...rows]
              next[index] = { ...row, label: event.currentTarget.value }
              onChange(next)
            }}
          />
          <TextInput
            label={index === 0 ? t('editorV2.form.fields.value') : undefined}
            placeholder="+1 234 567"
            value={row.value || ''}
            style={{ flex: 2 }}
            onChange={(event) => {
              const next = [...rows]
              next[index] = { ...row, value: event.currentTarget.value }
              onChange(next)
            }}
          />
          <ActionIcon
            color="red"
            variant="subtle"
            aria-label={t('editorV2.form.fields.removeContactRow')}
            onClick={() => onChange(rows.filter((_, rowIndex) => rowIndex !== index))}
          >
            <IconTrash size={16} />
          </ActionIcon>
        </Group>
      ))}
      {error && <Text size="xs" c="red">{error}</Text>}
    </Stack>
  )
}

export const collectionFieldRegistry = {
  'string-list': StringListField,
  'contact-list': ContactListField,
}
